// src/Pages/ThankYou.tsx
import { Helmet } from "react-helmet-async";

const ThankYou = () => {
  return (
    <>
      <Helmet>
        <title>Thank You | SkyAzul</title>
        <meta property="og:title" content="Thank You | SkyAzul" />
      </Helmet>
      <div className="container py-5 my-5 text-center">
        <h2 className="text-success mb-3">Thank You!</h2>
        <p className="lead">
          Your message has been successfully submitted. Our team will get back to you soon.
        </p>
      </div>
    </>
  );
};

export default ThankYou;
